import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LocationsInternalClient, CreateLocationRequest } from '../nswag/atlas/AtlasClient';

export default function useCreateApartment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (request: ICreateApartmentRequest) => {
      const client = new LocationsInternalClient();
      return await client.createApartment(request.createLocationRequest);
    },
    onSuccess: (_, request) => {
      queryClient.invalidateQueries({ queryKey: ['CUSTOMER', request.customerId] });
    },
  });
}

interface ICreateApartmentRequest {
  createLocationRequest: CreateLocationRequest;
  customerId: string;
}
